import React from 'react';

export interface StepCompletedProps {
  /** Label content */
  children: React.ReactNode;
}

export function StepCompleted(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  props: StepCompletedProps
) {
  return null;
}

StepCompleted.displayName = '@kubed/core/StepCompleted';
